import { useEffect } from 'react';

import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { useGetApiCarrousel } from '@/api';
import Carrousel from '@/components/Carrousel/Carrousel';
import InvestmentCard from '@/components/InvestmentCard/InvestmentCard';
import { useAuth } from '@/hooks/useAuth';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import { INVESTMENT_CARDS } from './constants/investmentCards';
import styles from './styles.module.css';

const PAGE_NOM = 'investir';

export const Investir: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { data: carrouselData, isLoading: isCarrouselLoading } = useGetApiCarrousel();

  useEffect(() => {
    globalThis.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    if (!user) return;

    TRACKING_INSTANCE.setTcVars({
      page_nom: PAGE_NOM,
      page_template: 'espace client',
      user_id: user.id,
      user_client: user.type === 'Client',
      user_connexion: user.success,
      user_statut_contrat: sessionStorage.getItem('user_statut_contrat'),
    });
    void TRACKING_INSTANCE.triggerEvent('page', undefined, {
      event_id: 'page',
      event_categorie: 'affichage espace client',
      event_nom: PAGE_NOM,
      event_page: PAGE_NOM,
    });
  }, [user?.id]);

  return (
    <div className={styles.investir}>
      <header className={styles.header}>
        <h1 className={styles.title}>{t('invest.title')}</h1>
        <p className={styles.subtitle}>{t('invest.subtitle')}</p>
      </header>

      <MtxGrid className={styles.cardsGrid} row>
        {INVESTMENT_CARDS.map((card) => (
          <MtxGrid col={4} colXs={12} colSm={6} colMd={6} colLg={4} key={card.id}>
            <InvestmentCard
              icon={card.icon}
              title={t(card.titleKey)}
              text={t(card.textKey)}
              buttonLabel={t('invest.cards.buttonLabel')}
              route={card.redirectUrl}
              trackingLabel={card.trackingLabel}
            />
          </MtxGrid>
        ))}
      </MtxGrid>

      {!!carrouselData?.carrousel?.length && (
        <section className={styles.offersSection}>
          <h2 className={styles.offersTitle}>{t('invest.offersTitle')}</h2>
          <MtxGrid row>
            <MtxGrid col={8} colXs={12} colSm={12} colMd={12} colLg={10}>
              <Carrousel data={carrouselData.carrousel} isLoading={isCarrouselLoading} />
            </MtxGrid>
          </MtxGrid>
        </section>
      )}
    </div>
  );
};
